import * as React from 'react'

import {Grid, Heading, Stack, Text} from '@chakra-ui/react'

import {MySupportGroupMeeting} from '@/api/models'
import useSupabaseQuery from '@/common/use-custom-query'
import {LoadingSpotlightItem} from '@/user/components/spotlight-item'
import {groupMeetings} from '@/user/meetings/utils'

import JoinableSupportGroupMeeting from './joinable'
import PlannedSupportGroupMeeting from './planned'

const SupportGroupMeetings = () => {
  const {data, loading, fetch} = useSupabaseQuery<MySupportGroupMeeting>(
    React.useMemo(
      () => ({
        table: 'my_support_group_meetings',
        fields: '*',
        order: 'joinable_from',
        errSnackbarTitle: 'Nie udało się pobrać nadchodzących spotkań grup wsparcia',
        filter: (b) => b.gte('joinable_to', new Date().toUTCString()).eq('role', 'member'),
      }),
      []
    )
  )

  const {joinable, planned} = React.useMemo(() => groupMeetings(data), [data])

  return (
    <Stack spacing={12}>
      <Heading size="md">Grupy wsparcia</Heading>
      {loading ? (
        <LoadingSpotlightItem />
      ) : !data?.length ? (
        <Text>Brak zaplanowanych spotkań</Text>
      ) : (
        <Stack spacing={6}>
          {!!joinable.length && (
            <>
              <Text fontSize="lg" fontWeight={500}>
                Trwające spotkania
              </Text>
              {joinable.map((m, i) => (
                <JoinableSupportGroupMeeting key={i} item={m} onReviewComplete={fetch} />
              ))}
            </>
          )}
          {!!planned.length && (
            <>
              <Text fontSize="lg" fontWeight={500}>
                Zaplanowane spotkania
              </Text>
              <Grid templateColumns={['repeat(1, 1fr)', 'repeat(2, 1fr)', 'repeat(3, 1fr)']} gap={8}>
                {planned.map((m, i) => (
                  <PlannedSupportGroupMeeting
                    key={i}
                    item={m}
                    borderRadius={(i + 2) % 3 === 0 ? '0px 50px' : '50px 0px'}
                    onReviewComplete={fetch}
                  />
                ))}
              </Grid>
            </>
          )}
        </Stack>
      )}
    </Stack>
  )
}

export default SupportGroupMeetings
